import React from 'react';

const Benefits: React.FC = () => {
  const differentiators = [
    {
      title: "A Focus on Dentistry",
      description: "We provide dental care for dogs and cats, alongside the care they receive from their primary veterinarian."
    },
    {
      title: "Care for Your Pet",
      description: "Discuss your pet’s health, dental findings, and proposed treatment with the veterinary team."
    },
    {
      title: "Planning Your Visit",
      description: "Ask what to expect before the procedure, during recovery, and at follow-up."
    },
    {
      title: "Transparent Pricing",
      description: "Published fees help you understand what is included and which treatments are billed separately."
    }
  ];

  return (
    <section id="benefits" className="bg-white py-12 lg:py-20">
      <div className="container-custom">
        <div className="grid lg:grid-cols-2 gap-12 items-center max-w-6xl mx-auto">
          {/* Left Side: Text Content */}
          <div className="order-2 lg:order-1">
            <h3 className="text-3xl sm:text-4xl font-bold text-hellotend-brand-brown mb-8 lg:mb-10 leading-[1.1] font-nantes" style={{fontWeight: 700}}>
              How We're Different
            </h3>
            
            {/* Grid of Bullets */}
            <div className="grid sm:grid-cols-2 gap-x-8 gap-y-10">
              {differentiators.map((item, index) => (
                <div key={index} className="flex items-start gap-3">
                  <div className="flex-shrink-0 w-2 h-2 bg-brand-teal rounded-full mt-2.5"></div>
                  <div className="flex-1">
                    <h4 className="text-xl font-semibold text-primary mb-2 leading-tight">
                      {item.title}
                    </h4>
                    <p className="text-base sm:text-lg text-gray-600 font-light leading-relaxed">
                      {item.description}
                    </p>
                  </div>
                </div>
              ))}
            </div>
          </div>
          
          {/* Right Side: Video */}
          <div className="order-1 lg:order-2 flex justify-center lg:justify-end">
            <div className="relative w-full max-w-md lg:max-w-full rounded-2xl overflow-hidden shadow-2xl">
              <video 
                src="/Chomp-Video-Spin.mp4" 
                autoPlay 
                loop 
                muted 
                playsInline
                preload="metadata"
                className="w-full h-auto object-cover"
                poster="/homeimagebouviercat.png"
                aria-label="Short clip of a happy pet after dental care at CHOMP (no sound)"
              >
                <source src="/Chomp-Video-Spin.mp4" type="video/mp4" />
                <img 
                  src="/homeimagebouviercat.png" 
                  alt="Happy pet after professional dental care in South Florida" 
                  loading="lazy"
                  width="1200"
                  height="675"
                  className="w-full h-auto object-cover"
                />
              </video>
              <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black/70 to-transparent p-6 pt-12">
                <p className="text-white text-base sm:text-lg font-semibold text-center">
                  Happy, healthy smiles are our specialty
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Benefits;
